(function () {
  "use strict";

  function normalized(value) {
    return String(value || "").toLocaleLowerCase().normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "").replace(/[’‘']/g, "")
      .replace(/[^\p{L}\p{N}]+/gu, " ").trim()
      .replace(/\b(raspberr|strawberr|blueberr|blackberr|cherr)ies\b/g, "$1y");
  }

  function initialize(root) {
    if (root.hasAttribute("data-cc-catalog-ready")) return;
    var groups = Array.from(root.querySelectorAll("[data-cc-recipe-group]"));
    var search = root.querySelector("[data-cc-catalog-search]");
    var clear = root.querySelector("[data-cc-catalog-clear]");
    var status = root.querySelector("[data-cc-catalog-status]");
    var empty = root.querySelector("[data-cc-catalog-empty]");
    var featured = root.querySelector("[data-cc-featured]");
    var controls = root.querySelector("[data-cc-catalog-controls]");
    var pageRoot = root.closest(".cc-recipes-v318safe") || root;
    var entries = groups.map(function (group) {
      return { element: group, count: group.querySelector("[data-cc-group-count]"),
        cards: Array.from(group.querySelectorAll("[data-cc-catalog-card]")) };
    });
    var uniqueKeys = new Set();
    entries.forEach(function (entry) {
      entry.cards.forEach(function (card) { uniqueKeys.add(card.dataset.ccRecipeKey); });
    });
    var total = uniqueKeys.size;
    var searching = false;
    var savedOpen = new Map();
    var searchTextCache = new WeakMap();
    var timer = 0;
    var navigationKey = "ccRecipeLibrary";

    function rememberNavigation() {
      if (!document.documentElement.contains(root)) return;
      try {
        var previous = window.history.state;
        if (previous && typeof previous !== "object") return;
        var next = Object.assign({}, previous || {});
        next[navigationKey] = {
          version: 1,
          path: window.location.pathname,
          query: search ? search.value : "",
          open: groups.filter(function (group) { return group.open; }).map(function (group) { return group.id; }),
          beforeSearch: groups.filter(function (group) {
            return searching ? savedOpen.get(group) : group.open;
          }).map(function (group) { return group.id; }),
          scrollY: window.scrollY
        };
        window.history.replaceState(next, "");
      } catch (error) {}
    }

    function restoreNavigation() {
      var state;
      try { state = window.history.state && window.history.state[navigationKey]; }
      catch (error) { return false; }
      if (!state || state.version !== 1 || state.path !== window.location.pathname ||
          typeof state.query !== "string" || !Array.isArray(state.open) || !Array.isArray(state.beforeSearch)) return false;
      window.clearTimeout(timer);
      searching = false;
      savedOpen.clear();
      groups.forEach(function (group) { group.open = state.beforeSearch.indexOf(group.id) !== -1; });
      if (search) search.value = state.query;
      applySearch();
      groups.forEach(function (group) { group.open = !group.hidden && state.open.indexOf(group.id) !== -1; });
      if (Number.isFinite(state.scrollY) && state.scrollY >= 0) {
        window.requestAnimationFrame(function () {
          window.scrollTo({ top: state.scrollY, left: 0, behavior: "instant" });
        });
      }
      return true;
    }

    function cardSearchText(card) {
      var source = card.dataset.searchText;
      var cached = searchTextCache.get(card);
      if (!cached || cached.source !== source) {
        cached = { source: source, value: normalized(source) };
        searchTextCache.set(card, cached);
      }
      return cached.value;
    }

    function applySearch() {
      var query = normalized(search && search.value);
      var words = query ? query.split(/\s+/) : [];
      var matched = new Set();
      if (query && !searching) {
        savedOpen.clear();
        groups.forEach(function (group) { savedOpen.set(group, group.open); });
      }
      entries.forEach(function (entry) {
        var visibleCount = 0;
        entry.cards.forEach(function (card) {
          var haystack = cardSearchText(card);
          var visible = words.every(function (word) { return haystack.indexOf(word) !== -1; });
          card.hidden = !visible;
          if (visible) {
            visibleCount += 1;
            matched.add(card.dataset.ccRecipeKey);
          }
        });
        entry.element.hidden = visibleCount === 0;
        if (query) entry.element.open = visibleCount > 0;
        else if (searching && savedOpen.has(entry.element)) entry.element.open = savedOpen.get(entry.element);
        if (entry.count) entry.count.textContent = String(visibleCount);
      });
      if (featured) featured.hidden = Boolean(query);
      if (clear) clear.hidden = !(search && search.value);
      if (empty) empty.hidden = matched.size !== 0;
      if (status) {
        var message = status.getAttribute(query ? "data-cc-message-results" : "data-cc-message-all") || "";
        status.textContent = message.replace("__COUNT__", String(matched.size)).replace("__TOTAL__", String(total));
      }
      searching = Boolean(query);
    }

    function clearSearch() {
      window.clearTimeout(timer);
      if (search) search.value = "";
      applySearch();
    }

    function revealTarget(id, moveFocus) {
      var target = document.getElementById(id);
      if (!target || !root.contains(target)) return false;
      var group = target.matches("[data-cc-recipe-group]") ? target : target.closest("[data-cc-recipe-group]");
      if (!group) return false;
      clearSearch();
      group.hidden = false;
      group.open = true;
      if (moveFocus) {
        var focusTarget = target === group ? group.querySelector("summary") : target.querySelector("a");
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
      return true;
    }

    function currentHashTarget() {
      try { return decodeURIComponent(window.location.hash.slice(1)); }
      catch (error) { return ""; }
    }

    if (search) {
      search.addEventListener("input", function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(applySearch, 100);
      });
      search.addEventListener("search", function () {
        window.clearTimeout(timer);
        applySearch();
      });
      search.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && search.value) {
          event.preventDefault();
          clearSearch();
        }
      });
    }
    if (clear) {
      clear.addEventListener("click", function () {
        clearSearch();
        if (search) search.focus();
      });
    }
    pageRoot.querySelectorAll("[data-cc-catalog-filter-link]").forEach(function (link) {
      link.addEventListener("click", function () {
        revealTarget("ccr-group-" + link.dataset.ccCatalogFilterLink, true);
      });
    });
    window.addEventListener("hashchange", function () {
      var id = currentHashTarget();
      if (revealTarget(id, true)) {
        var target = document.getElementById(id);
        if (target) target.scrollIntoView({ block: "start" });
      }
    });
    window.addEventListener("pagehide", rememberNavigation);
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted && document.documentElement.contains(root)) restoreNavigation();
    });

    root.setAttribute("data-cc-catalog-ready", "true");
    if (controls) controls.hidden = false;
    if (restoreNavigation()) return;
    applySearch();
    var initialId = currentHashTarget();
    if (revealTarget(initialId, false)) {
      window.requestAnimationFrame(function () {
        var target = document.getElementById(initialId);
        if (target) target.scrollIntoView({ block: "start" });
      });
    }
  }

  function initializeWithin(scope) {
    if (scope.matches && scope.matches("[data-cc-catalog]")) initialize(scope);
    scope.querySelectorAll("[data-cc-catalog]").forEach(initialize);
  }

  initializeWithin(document);
  document.addEventListener("shopify:section:load", function (event) { initializeWithin(event.target); });
})();
